import { RootState } from '..';
import { PortraitGroups } from 'src/utils/pick-portrait-pair';

const EMPTY_INTRO_IMAGES: PortraitGroups = { left: [], right: [] };

export const selectAllData = (state: RootState) => {
  return state.data;
};

export const selectVersion = (state: RootState) => {
  return state.data.main.versionId;
};

export const selectVersionMismatch = (state: RootState) => {
  return state.data.versionMismatch;
};

export const selectIntroImages = (state: RootState): PortraitGroups => {
  return state.data.main.openingImages ?? EMPTY_INTRO_IMAGES;
};

export const selectParties = (state: RootState) => {
  return state.data.main.parties;
};

export const selectSeo = (state: RootState) => {
  return state.data.main.seo;
};

export const selectShares = (state: RootState) => {
  return state.data.main.sharing;
};

export const selectDuels = (state: RootState) => {
  return state.data.duels;
};

export const selectLoadingDuels = (state: RootState) => {
  return state.data.loadingDuels;
};

export const selectStatements = (state: RootState) => {
  return state.data.statements;
};

export const selectLoadingStatements = (state: RootState) => {
  return state.data.loadingStatements;
};

export const selectResults = (state: RootState) => {
  return state.data.results;
};

export const selectLoadingResults = (state: RootState) => {
  return state.data.loadingResults;
};

